module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--rewards-filter"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--rewards-filter__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [_c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.modal_title')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('rewards-filters', {
    ref: "rewardsFilters"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__actions c-modal--rewards-filter__box__actions"
  }, [_c('div', {
    staticClass: "c-modal--rewards-filter__box__actions__left"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-info",
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.clear_button')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--rewards-filter__box__actions__right"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-plain",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.cancel_button')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button\n                    t-button-primary\n                    qa-apply-filters-button",
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.catalog_rewards_filter_modal.apply_button')) + "\n        ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6419bba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/RewardsFilterModal.vue
// module id = 544
// module chunks = 1